/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The PropertyEmailOption model module.
 * @module model/PropertyEmailOption
 * @version 1.0.0
 */
export class PropertyEmailOption {
  /**
   * Constructs a new <code>PropertyEmailOption</code>.
   * @alias module:model/PropertyEmailOption
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PropertyEmailOption</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PropertyEmailOption} obj Optional instance to populate.
   * @return {module:model/PropertyEmailOption} The populated <code>PropertyEmailOption</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PropertyEmailOption();
      if (data.hasOwnProperty('key'))
        obj.key = ApiClient.convertToType(data['key'], 'String');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} key
 */
PropertyEmailOption.prototype.key = undefined;

/**
 * @member {String} title
 */
PropertyEmailOption.prototype.title = undefined;

/**
 * @member {String} description
 */
PropertyEmailOption.prototype.description = undefined;

/**
 * @member {Boolean} enabled
 */
PropertyEmailOption.prototype.enabled = undefined;

